angular.module('unica_invitation_transfer_event.invitation_transfer_event_services')

.factory('InvitationTransferEventEditService', function ($http, getBaseApiURL) {
	
	var invitationTransferEventEditService = {};

	invitationTransferEventEditService.sendNotifications = function ( invitationTransferData ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-transfer-event/send-notifications',
			data: invitationTransferData
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});

	};

	return invitationTransferEventEditService;
});

